<template>
  <section
    id="batchingID"
    class="new-case-view case-creation"
    v-loading="loading"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="container-small-table">
      <div class="case-status">
        <el-row>
          <el-col :xl="24" :lg="24">
            <ul class="justify-content-start">
              <li v-if="form.title">
                <h3 class="name">
                  {{ form.title }}
                </h3>
              </li>
              <li>
                <el-button class="btn-active">
                  {{
                    form.case_type == "PULMONARY_PANEL"
                      ? "PULMONARY PANEL"
                      : "Cardaic"
                  }}
                </el-button>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>

      <div class="primary-content-view-new">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
        >
          <el-table :data="form.accession_data" height="calc(100vh - 300px)">
            <el-table-column
              width="200"
              label="Accession ID"
              prop="accession_id"
            >
              <template #default="scope">
                <div class="name-accession">
                  <span id="accession-id" @click="goToCaseView(scope.row._id)">
                    {{ scope.row.accession_id }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Report Status"
              prop="report_status"
              width="200"
            >
              <template #default="scope">
                <div class="column-status">
                  <el-tag
                    :type="
                      getReportsStatus(scope.row.report_status || getStyle)
                    "
                    >{{ scope.row.report_status }}</el-tag
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="message"
              label="Message"
              min-width="200"
            ></el-table-column>
            <el-table-column label="Actions" width="200">
              <template v-slot="scope">
                <ul class="listings__action-buttons">
                  <li v-if="scope.row.report_status == 'COMPLETED'">
                    <el-button
                      @click="onDownloadReport(scope.row)"
                      class="view-button"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/download-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/download-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li v-if="scope.row.report_status == 'COMPLETED'">
                    <el-button
                      @click="viewReport(scope.row)"
                      class="view-button"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/view-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/view-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li v-if="scope.row.report_status == 'FAILED'">
                    <el-button @click="regenerateFailedReport(scope.row)">
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/restore-icon-danger.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/restore-icon-danger.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>

                  <li
                    v-if="
                      scope.row.report_status == 'COMPLETED' &&
                      !scope.row.is_finalized
                    "
                  >
                    <el-button
                      class="finalize-btn"
                      @click="finalizeReport(scope.row)"
                      :disabled="
                        !hasPermission('test_report', 'finalize_report')
                      "
                    >
                      Finalize
                    </el-button>
                  </li>
                  <li
                    class="d-flex align-center"
                    v-if="scope.row.is_finalized == true"
                  >
                    <el-button class="finalized-btn">Finalized </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import FileDownloadHelper from "@/mixins/FileDownloadHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";

export default {
  name: "CardiacCasesForReport",
  mixins: [UserPermissionsHelper, FileDownloadHelper],
  data() {
    return {
      loading: false,
      dialogSelectCase: false,
      case_type: "",
      loadingText: "Loading...",
      form: {
        title: "",
        case_type: "",
        status: "ACTIVE",
        sent_status: false,
        report_data: "",
        accession_data: [],
      },
      reportFileId: "",
    };
  },
  computed: {
    getReportsStatus() {
      return (statusVal) => {
        const status = statusVal;
        if (status == "FAILED") {
          return "danger";
        } else if (status == "COMPLETED") {
          return "success";
        } else {
          return "";
        }
      };
    },
    getStyle(status) {
      if (status === "FAILED") {
        return "danger";
      } else if (status === "COMPLETED") {
        return "success";
      } else {
        return "";
      }
    },
    ...mapGetters("reportFiles", [
      "getReportFileById",
      "getFinalizeReportStatus",
      "getSyncReportStatus",
    ]),
    ...mapGetters("errors", ["getErrors"]),
    ...mapGetters("respiratoryFileUpload", ["getFileDownloadUrl"]),
  },
  async mounted() {
    if (this.$route.params.id) {
      this.reportFileId = this.$route.params.id;
      await this.getReport();
    }
  },
  methods: {
    async getReport() {
      this.loading = true;

      await this.$store.dispatch("reportFiles/show", this.$route.params.id);
      this.setFormData();
      this.loading = false;
    },

    setFormData() {
      this.form = { ...this.getReportFileById };
      this.case_type = this.form.case_type;
    },

    // Actions of single case
    async regenerateFailedReport(report) {
      let params = {
        id: this.form._id,
        accession_id: report.accession_id,
      };
      this.loading = true;
      await this.$store.dispatch(
        "reportFiles/syncCaseForReportChanges",
        params
      );
      this.loading = false;
      if (this.getSyncReportStatus) {
        successNotification("Reports syncing process started successfully");
        this.getReport();
      }
    },
    async onDownloadReport(report) {
      this.loading = true;
      this.loadingText = "Downloading Report....";
      await this.$store.dispatch("respiratoryFileUpload/fetchFileDownloadUrl", {
        path: report.report_path,
      });

      let url = this.getFileDownloadUrl.download_url;
      const title = (this.form.title + "_" + report.accession_id).replace(
        /\s/g,
        "_"
      );
      await this.renameAndDownloadFile(url, title);
      this.loading = false;
    },
    async finalizeReport(report) {
      this.loading = true;
      await this.$store.dispatch("reportFiles/finalizeCaseReport", {
        id: this.reportFileId,
        accession_id: report.accession_id,
      });
      this.loading = false;
      if (this.getFinalizeReportStatus) {
        successNotification("Report Finalized successfully");
        this.getReport();
      } else if (!this.getErrors) {
        errorNotification("Error in finalize report");
      }
    },
    async viewReport(report) {
      try {
        await this.$store.dispatch(
          "respiratoryFileUpload/fetchFileDownloadUrl",
          {
            path: report.report_path,
          }
        );

        let url = this.getFileDownloadUrl.download_url;
        this.downloadFileAndPreviewFile(url);
      } catch (err) {
        this.loading = false;
      }
    },
    // End actions
  },
  filters: {
    getPatientName(val) {
      return val;
    },
  },
};
</script>

<style lang="scss"></style>
